import styled from 'styled-components'

import {StaticBasicStyles} from '@/src/shared/assets/styles/static'

export const Static = styled.div`
  ${StaticBasicStyles}
`
